export default function sortFirstThenLastName (a, b) {
  const aFirstName = a?.firstName ?? ''
  const bFirstName = b?.firstName ?? ''
  const aLastName = a?.lastName ?? ''
  const bLastName = b?.lastName ?? ''
  return aFirstName.localeCompare(bFirstName) || aLastName.localeCompare(bLastName)
}
